import React from "react";
import { SectionLabel, Reveal } from "../primitives";
import { Section, H2, BODY } from "../shared";

export default function HookSection() {
  return (
    <Section testId="hook-section" className="py-24 md:py-36">
      <div className="grid gap-10 md:grid-cols-12">
        <div className="md:col-span-3">
          <SectionLabel testId="hook-label">Der Satz</SectionLabel>
        </div>
        <div className="md:col-span-9 md:max-w-2xl">
          <Reveal>
            <h3 className={`${H2} mb-10 text-3xl md:text-5xl`}>Eigentlich ist alles gut.</h3>
          </Reveal>
          <div className="space-y-6">
            <Reveal delay={0.05}><p className={BODY}>Du hast eigentlich alles.</p></Reveal>
            <Reveal delay={0.08}>
              <p className={BODY}>Den Job, um den Dich andere beneiden.</p>
            </Reveal>
            <Reveal delay={0.09}>
              <p className={BODY}>Die Sicherheit und das gute Gehalt jeden Monat auf Deinem Konto.</p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className={BODY}>Den Lebensstandard, von dem Du mal geträumt hast.</p>
            </Reveal>
            <Reveal delay={0.11}>
              <p className={BODY}>Anerkennung. Gutes Feedback. Man schätzt Dich.</p>
            </Reveal>
            <Reveal delay={0.1}><p className={BODY}>Und trotzdem...</p></Reveal>
            <Reveal delay={0.12}>
              <p className={BODY}>
                ist da in Dir <strong className="font-600 text-espresso" style={{ fontWeight: 600 }}>diese Leere und die Sehnsucht nach mehr.</strong>
              </p>
            </Reveal>
            <Reveal delay={0.14}>
              <p className={BODY}>
                Über die Du mit niemandem sprichst. Weil, wenn Du's versuchst, kommt sofort: <em className="text-cognac-2">„Aber Du hast doch so ein Glück mit Deinem Job.“</em>
              </p>
            </Reveal>
            <Reveal delay={0.16}>
              <p className={BODY}>
                Also schweigst Du. Setzt ein Lächeln auf und sagst Dir, immer wenn der Zweifel hochkommt:
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="font-heading text-2xl font-600 uppercase leading-tight tracking-tight text-espresso md:text-4xl" style={{ fontWeight: 600 }}>
                „Ist doch eigentlich alles gut. Was will ich denn noch?“
              </p>
            </Reveal>
            <Reveal delay={0.24}>
              <p className={`${BODY} italic text-cognac-2`}>
                Diese Stimme ist nicht ohne Grund da. Und sie geht auch nicht weg, nur weil Du sie ignorierst.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </Section>
  );
}
